import i, { forwardRef as U } from "react";
import { useFormContext as W } from "react-hook-form";
import R from "classnames";
import { Label as X } from "../Label/Label.js";
import r from "./textInput.module.scss.js";
function q(e, c) {
  if (e != null)
    return c === "date" && e instanceof Date ? e.toISOString().split("T")[0] : String(e);
}
function Y(e, c) {
  if (!e) return null;
  if (c === "date") {
    const o = new Date(e);
    return Number.isNaN(o.getTime()) ? null : o;
  }
  return e;
}
const te = U(
  ({
    label: e = "",
    placeholder: c = "",
    noPadded: o = !1,
    detectTouched: x = !0,
    showBorder: V = !1,
    type: l = "text",
    value: b,
    defaultValue: y,
    onChange: _,
    onBlur: N,
    name: n,
    design: {
      textColor: a,
      labelColor: E = a,
      errorColor: $ = "#F44336",
      backgroundColor: L = "transparent",
      borderColor: O = a
    },
    isError: S,
    formOptions: j,
    customChangeHandler: w,
    skipRHFValue: z,
    testId: f,
    ...k
  }, d) => {
    var g, v, D;
    const s = W(), u = s && n, m = u ? s.formState.errors[n] : void 0, p = i.useRef(null), F = u ? !m : ((v = (g = p == null ? void 0 : p.current) == null ? void 0 : g.checkValidity) == null ? void 0 : v.call(g)) ?? !0, [A, T] = i.useState(!1), h = x ? (!F || S) && A : !F || S, G = q(
      u && !z ? s.getValues()[n] ?? "" : b,
      l
    ), H = q(y, l), J = async (t) => {
      if (w) {
        w(t);
        return;
      }
      const Q = Y(t.target.value, l);
      u && (s.setValue(n, Q), await s.trigger()), _ == null || _(t);
    }, K = () => T(!0), M = (t) => {
      T(!0), N == null || N(t);
    }, P = u ? s.register(n, {
      required: k.required,
      ...j
    }) : void 0;
    return /* @__PURE__ */ i.createElement(
      "div",
      {
        "data-testid": f ? `${f}-wrapper` : "text-input-wrapper",
        style: {
          "--textColor": a,
          "--error-color": $,
          "--background-color": L,
          "--border-color": O || a,
          "--label-color": E || a
        }
      },
      /* @__PURE__ */ i.createElement(
        X,
        {
          text: e ?? "",
          textColor: a,
          labelColor: E || a,
          noPadded: o
        },
        /* @__PURE__ */ i.createElement("div", { className: r.wrapper }, !V && /* @__PURE__ */ i.createElement(
          "div",
          {
            className: R(r.line, {
              [r.error]: h
            })
          }
        ), /* @__PURE__ */ i.createElement(
          "input",
          {
            "data-testid": f ? `${f}` : "text-input",
            name: n,
            className: R({
              [r.input]: !0,
              [r.inputFilled]: !!b,
              [r.input__notPadded]: o,
              [r.input__bordered]: V,
              [r.input__bordered__error]: h && V
            }),
            value: G,
            defaultValue: H,
            type: l,
            placeholder: c ?? "",
            ...P,
            onClick: K,
            onChange: J,
            onBlur: M,
            ref: (t) => {
              p.current = t, typeof d == "function" ? d(t) : d && (d.current = t);
            },
            ...k
          }
        )),
        !!m && !!m.message && /* @__PURE__ */ i.createElement("div", { className: r.error }, (D = m.message) == null ? void 0 : D.toString())
      )
    );
  }
);
export {
  te as TextInput
};
//# sourceMappingURL=TextInput.js.map
